import Vue from 'vue';
import { uuidv4 } from '../../utility';
import Notification from './notification-container';

export const DEFAULT_OPTIONS = {
  snackbar: false,
  y: 'top',
  x: 'right',
  /** DO NOT USE MODE. It's not implemented yet */
  mode: '',
  /** 'error' or 'normal' */
  type: 'normal',

  // NOW IMPORTANT OPTIONS/PROP
  timeout: 6000,
  text: 'Hello, I\'m a snackbar',
  top: 0,
};

export const NotificationService = {
  notificationComponent: null,
  notificationList: [],
  notificationPane: null,
  mount: function () {
    this.notificationPane = document.createElement('div');
    this.notificationPane.style = `
      // background: black;
      position: fixed;
      // height: 48px;
      // width: 600px;
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
      top: 4px;
      right: 8px;
      align-items: end;
      z-index: 99;
    `;


    document.body.appendChild(this.notificationPane);
  },
  createNotificationComponent: function () {
    const component = new Vue(Notification);
    if (!this.notificationPane) {
      this.mount();
    }
    this.notificationPane.appendChild(component.$mount().$el);

    console.log("mounting Shit", this.notificationPane, component);
    return component;
  },
  showNotification: function (options = DEFAULT_OPTIONS) {
    // if (!this.notificationComponent) {
    //   this.notificationComponent = this.createNotificationComponent();
    // }

    options.timeout = options?.timeout ? options?.timeout : 5000;
    options.mode = options?.mode ? options?.mode : 'normal';

    const newId = uuidv4();
    const newNotification = {
      id: newId,
      component: this.createNotificationComponent(),
      options: {
        ...options,
        id: newId,
      },
    };

    this.notificationList = [
      ...this.notificationList,
      newNotification,
    ];

    // Reversing the Top of Notifications
    // this.notificationList = this.notificationList.map((e, i) => {
    //   return {
    //     ...e,
    //     options: {
    //       ...e.options,
    //       top: ((this.notificationList?.length - i) * 48 - 48)
    //     }
    //   }
    // })

    // newNotification.component.show(options);

    this.notificationList.forEach(notification => {
      notification.component.show(notification.options)
    });

    // this.notificationComponent.show(options);

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log({ "tTimeout": 1 });

        if (newNotification.component) {
          newNotification.component.close();
        }

        resolve();


        // Clearing the Notification Array
        this.closeNotification(newNotification.id);


      }, options.timeout)
    });
  },
  closeNotification: function (id) {
    this.notificationList = this.notificationList.filter(notification => {
      if (notification.id == id) {
        notification.component.close();
        notification.component.$destroy();
        notification.component.$el.parentNode.removeChild(notification.component.$el);
        return false;
      }
      return true;
    })
  }
}


export const showError = (message, timeout = 5000) => {
  NotificationService.showNotification({
    text: message,
    type: "error",
    timeout,
  });
}
export const showNotification = (message, timeout = 5000) => {
  NotificationService.showNotification({
    text: message,
    type: "normal",
    timeout,
  });
}

window.NotificationService=NotificationService;